import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bg-white rounded border border-gray-200 p-3 mb-6" }
const _hoisted_2 = { class: "w-40" }
const _hoisted_3 = { class: "w-48" }
const _hoisted_4 = ["disabled"]

import { ref, watch } from 'vue'
import type { MelFilters } from '@/types'

interface Props {
  modelValue: MelFilters
  isLoading?: boolean
}

interface Emits {
  (e: 'update:modelValue', value: MelFilters): void
  (e: 'filter', values: MelFilters): void
}


export default /*@__PURE__*/_defineComponent({
  __name: 'FiltersCompact',
  props: {
    modelValue: {},
    isLoading: { type: Boolean, default: false }
  },
  emits: ["update:modelValue", "filter"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

// Local state pour les filtres (avec tous les champs initialisés)
const localFilters = ref<MelFilters>({ 
  idShooting: props.modelValue.idShooting || '',
  reference: props.modelValue.reference || '',
  confirmation: props.modelValue.confirmation || '',
  dateDemandeDebut: props.modelValue.dateDemandeDebut || '',
  dateDemandeFin: props.modelValue.dateDemandeFin || '',
  dateShootingDebut: props.modelValue.dateShootingDebut || '',
  dateShootingFin: props.modelValue.dateShootingFin || ''
})

// Watch pour synchroniser avec le parent
watch(() => props.modelValue, (newValue) => {
  localFilters.value = { 
    idShooting: newValue.idShooting || '',
    reference: newValue.reference || '',
    confirmation: newValue.confirmation || '',
    dateDemandeDebut: newValue.dateDemandeDebut || '',
    dateDemandeFin: newValue.dateDemandeFin || '',
    dateShootingDebut: newValue.dateShootingDebut || '',
    dateShootingFin: newValue.dateShootingFin || ''
  }
}, { deep: true })

// Watch pour émettre les changements vers le parent
watch(() => localFilters.value, (newValue) => {
  emit('update:modelValue', { ...newValue })
}, { deep: true })

// Fonction pour réinitialiser les filtres
const resetFilters = () => {
  const emptyFilters = {
    idShooting: '',
    reference: '',
    confirmation: '',
    dateDemandeDebut: '',
    dateDemandeFin: '',
    dateShootingDebut: '',
    dateShootingFin: ''
  }
  localFilters.value = emptyFilters
  emit('filter', emptyFilters)
}

// Émettre l'événement de filtrage au backend avec les valeurs
const handleSubmit = () => {
  emit('filter', { ...localFilters.value })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("form", {
      onSubmit: _withModifiers(handleSubmit, ["prevent"]),
      class: "flex flex-wrap items-end gap-3"
    }, [
      _createElementVNode("div", _hoisted_2, [
        _cache[2] || (_cache[2] = _createElementVNode("label", { class: "text-xs font-medium text-black mb-1 block" }, "ID Shooting", -1)),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((localFilters.value.idShooting) = $event)),
          type: "text",
          placeholder: "Ex: 159428",
          class: "w-full px-3 py-2 text-sm border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
        }, null, 512), [
          [
            _vModelText,
            localFilters.value.idShooting,
            void 0,
            { trim: true }
          ]
        ])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _cache[3] || (_cache[3] = _createElementVNode("label", { class: "text-xs font-medium text-black mb-1 block" }, "Référence Produit", -1)),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((localFilters.value.reference) = $event)),
          type: "text",
          placeholder: "Ex: REF-123",
          class: "w-full px-3 py-2 text-sm border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
        }, null, 512), [
          [
            _vModelText,
            localFilters.value.reference,
            void 0,
            { trim: true }
          ]
        ])
      ]),
      _createElementVNode("button", {
        type: "submit",
        disabled: _ctx.isLoading,
        class: "px-4 py-2 text-sm font-medium bg-blue-600 text-white rounded hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
      }, [
        _cache[4] || (_cache[4] = _createElementVNode("i", { class: "fas fa-search mr-1" }, null, -1)),
        _createTextVNode(" " + _toDisplayString(_ctx.isLoading ? 'Recherche...' : 'Rechercher'), 1)
      ], 8, _hoisted_4),
      _createElementVNode("button", {
        type: "button",
        onClick: resetFilters,
        class: "px-4 py-2 text-sm font-medium bg-gray-200 text-black rounded hover:bg-gray-300 transition-colors"
      }, _cache[5] || (_cache[5] = [
        _createElementVNode("i", { class: "fas fa-times mr-1" }, null, -1),
        _createTextVNode(" Réinitialiser ")
      ]))
    ], 32)
  ]))
}
}

})